// extracted by mini-css-extract-plugin
export default {"backdrop":"OrderModal_backdrop__j9Eam","image":"OrderModal_image__pX7Ur"};